import { Component } from '@angular/core';
import { LanguageSelectorComponent } from '../../components/language-selector/language-selector.component';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-case-paid-dialog',
  templateUrl: './case-paid-dialog.component.html',
  styleUrls: ['./case-paid-dialog.component.scss'],
  imports: [LanguageSelectorComponent, MatButton, TranslateModule],
})
export class CasePaidDialogComponent {}
